import BidsSortableList from "components/bids/bidsSortableList";
import Loader from "components/shared/loader";
import React from "react";
import Item from "./item";

export default class DistributionBidsList extends BidsSortableList {
    renderRow = (item, index) => {
        const {
            roles,
            enums,
            history,
            params,
            organization,
            showFullAddress,
            showAllPointAddresses,
            showOrganizationColumn,
            showCostAwareValues,
            mergeParams,
            modal,
        } = this.props;
        return (
            <Item
                key={item.id}
                {...{
                    modal,
                    mergeParams,
                    item,
                    roles,
                    enums,
                    history,
                    index,
                    params,
                    organization,
                    showFullAddress,
                    showAllPointAddresses,
                    showOrganizationColumn,
                    showCostAwareValues,
                    className: this.context.prevItemId === item.id ? "book-tr__prev-row" : "",
                }}
            />
        );
    };

    thead = () => {
        return (
            <thead className="thead-light sticky-header">
                <tr className="b-table__header">
                    <th>#</th>
                    <th className={this.headerClass("id")}>{this.sortableDropdHeader("id", "ID")}</th>
                    <th className={this.headerClass("from")}>{this.sortableDropdHeader("from", "Откуда")}</th>
                    {this.props.showAllPointAddresses && <th>Транзит</th>}
                    <th className={this.headerClass("to")}>{this.sortableDropdHeader("to", "Куда")}</th>
                    <th className="b-table__cargo-cell">Груз, прицеп</th>
                    <th className={this.headerClass("priceWithoutCosts")}>
                        {this.props.showCostAwareValues
                            ? this.sortableDropdHeader("priceWithoutCosts", "Стоимость с учётом затрат, дистанция, контрагент")
                            : "Стоимость, дистанция, контрагент"}
                    </th>
                    <th>
                        {this.props.showCostAwareValues
                            ? `Выработка с учётом затрат (${this.props.organization?.currencyData?.name}/км)`
                            : `Выработка (${this.props.organization?.currencyData?.name}/км)`}
                    </th>
                    <th>Источник</th>
                    {this.props.showOrganizationColumn && <th>Организация</th>}
                    <th>Статус</th>
                </tr>
            </thead>
        );
    };

    tbody = () => {
        const { items } = this.props;
        return items && items.length ? (
            items.map(this.renderRow)
        ) : (
            <tr>
                <td colSpan={7} className="text-center">
                    Не найдено
                </td>
            </tr>
        );
    };

    table = () => {
        const { isLoadingList } = this.props;
        if (isLoadingList) {
            return <Loader prefix="absolute-center" />;
        }
        return (
            <table className="table table-hover table-clickable table-sm">
                {this.thead()}
                <tbody>{this.tbody()}</tbody>
            </table>
        );
    };

    render() {
        return (
            <>
                <div className="list__body-wrap">
                    <div className="list__body">
                        <div className="overflow-auto" style={{ height: "100%" }}>
                            <div className="container-fluid h-100">
                                <div
                                    className="table-responsive content-wrapper h-100"
                                    onScroll={this.scrollHandler}
                                    ref={(el) => (this.scrollContainer = el)}
                                >
                                    {this.table()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.renderPagination()}
            </>
        );
    }
}
